import { IShape } from '../../dependents';
import { GAnimateCfg } from '../../interface';
import { AnimateExtraCfg } from '../interface';

/**
 * @ignore
 * åæ ç§»å¨å¨ç»
 * @param shape å¾å½¢
 * @param animateCfg
 * @param cfg
 */
export function positionUpdate(shape: IShape, animateCfg: GAnimateCfg, cfg: AnimateExtraCfg) {
  const { toAttrs } = cfg;
  // @ts-ignore
  const x = toAttrs.x;
  // @ts-ignore
  const y = toAttrs.y;

  // @ts-ignore
  delete toAttrs.x;
  // @ts-ignore
  delete toAttrs.y;

  shape.attr(toAttrs);

  shape.animate(
    {
      x,
      y,
    },
    animateCfg
  );
}
